"use strict";

import { TopBarConstants } from 'Constants/TopBarConstants';
import { AppDispatcher } from 'Dispatcher';
export function clickUserMenu(el) {
  AppDispatcher.dispatch({
    actionType: TopBarConstants.CLICK_USER_MENU,
    anchorMenuEl: el
  });
}
export function closeUserMenu() {
  AppDispatcher.dispatch({
    actionType: TopBarConstants.CLOSE_USER_MENU
  });
}
export function topBarSetTitle(title) {
  AppDispatcher.asyncDispatch({
    actionType: TopBarConstants.TOP_BAR_SET_TITLE,
    title: title
  });
}
export function topBarSetDynToolBar(tb) {
  AppDispatcher.dispatch({
    actionType: TopBarConstants.TOP_BAR_SET_DYNAMIC_TOOLBAR,
    tb: tb
  });
}
export function topBarSetDynToolBarContent(content) {
  AppDispatcher.asyncDispatch({
    actionType: TopBarConstants.TOP_BAR_SET_DYN_TB_CONTENT,
    content: content
  });
}